import React from 'react';
import { IonAvatar, IonText, IonIcon, IonButton } from '@ionic/react';
import { callOutline, logoTwitter, logoInstagram, shareOutline } from 'ionicons/icons';
import './SpeakerHeader.css';

interface SpeakerHeaderProps {
  name: string;
  title: string;
  avatar: string;
  logo?: string;
  onCall?: () => void;
  onTwitter?: () => void;
  onInstagram?: () => void;
  onShare?: () => void;
}

const SpeakerHeader: React.FC<SpeakerHeaderProps> = ({
  name,
  title,
  avatar,
  logo,
  onCall,
  onTwitter,
  onInstagram,
  onShare
}) => {
  return (
    <div className="speaker-header">
      <div className="speaker-header-content">
        <div className="speaker-info">
          <IonText color="medium" className="speaker-title">
            {title}
          </IonText>
          <IonText>
            <h1 className="speaker-name">{name}</h1>
          </IonText>
          {logo && (
            <div style={{ marginTop: '8px' }}>
              <img
                src={logo}
                alt={`${name} logo`}
                style={{
                  maxHeight: '50px',
                  maxWidth: '150px',
                  objectFit: 'contain'
                }}
              />
            </div>
          )}
        </div>
        <IonAvatar className="speaker-avatar">
          <img src={avatar} alt={name} />
        </IonAvatar>
      </div>
      
      {/*<div className="speaker-actions">
        {onCall && (
          <button className="action-button" onClick={onCall}>
            <IonIcon icon={callOutline} />
            <span>Llamar</span>
          </button>
        )}
        
        {onTwitter && (
          <button className="action-button" onClick={onTwitter}>
            <IonIcon icon={logoTwitter} />
            <span>Twitter</span>
          </button>
        )}
        
        {onInstagram && (
          <button className="action-button" onClick={onInstagram}>
            <IonIcon icon={logoInstagram} />
            <span>Instagram</span>
          </button>
        )}
        
        {onShare && (
          <button className="action-button" onClick={onShare}>
            <IonIcon icon={shareOutline} />
            <span>Compartir</span>
          </button>
        )}
      </div>*/}
    </div>
  );
};

export default SpeakerHeader;
